import {DomainModel, DomainValidityStatusesEnum} from '../../models/api/domainModel';

/*
 * Helpers.
 */

export function isDomainValidityCheckRequired(domain?: DomainModel) {
  if (!domain) {
    return false;
  }
  return domain.validityStatus === DomainValidityStatusesEnum.TO_BE_CHECKED;
}
